import React, { useEffect, useState } from 'react';
import FareEstimateFormSkeletonLoaderCmp from './FareEstimateFormSkeletonLoaderCmp';
import { loadGoogleMapsApi } from '../utils/GoogleMapsScriptLoader';

interface GoogleMapsApiLoaderProps {
  children: React.ReactNode;
  apiKey: string;
  loader?: JSX.Element;
  libraries?: string[];
}

const GoogleMapsApiLoader: React.FC<GoogleMapsApiLoaderProps> = ({
  children,
  apiKey,
  loader = <FareEstimateFormSkeletonLoaderCmp />,
  libraries = ['places'],
}) => {
  const [isApiLoaded, setIsApiLoaded] = useState(false);
  const [isApiError, setIsApiError] = useState(false);

  useEffect(() => {
    loadGoogleMapsApi(apiKey, 3, 100, libraries)
      .then(() => {
        setIsApiLoaded(true);
      })
      .catch(() => {
        setIsApiError(true);
      });
  }, [apiKey, libraries]);

  if (isApiError) {
    return <div data-testid="maps-error">Failed to load Google Maps API</div>;
  }

  if (!isApiLoaded) {
    return loader || null;
  }

  return <>{children}</>;
};

export default GoogleMapsApiLoader;
